module.exports = __webpack_public_path__ + "img/7_OM.59e7196b.jpg";